export default "__VITE_ASSET__Czv9wmzP__"